var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "simpleSelect", class: _vm.mainClass }, [
    _c(
      "div",
      {
        class: [
          _vm.headerClass,
          _vm.disabled ? _vm.headerClass + "__disabled" : "",
          _vm.hasError ? "has-error" : "",
          _vm.open ? _vm.headerClass + "__open" : "" + _vm.headerClass
        ]
      },
      [
        _vm._t(
          "selected_option",
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search"
                }
              ],
              ref: "search",
              class: [
                _vm.disabled
                  ? _vm.inputClass + "__disabled"
                  : "" + _vm.inputClass
              ],
              attrs: {
                id: _vm.inputId,
                placeholder: _vm.selectedLabel,
                disabled: _vm.disabled,
                tabindex: _vm.tabindex,
                autocomplete: "no"
              },
              domProps: { value: _vm.search },
              on: {
                focus: function($event) {
                  _vm.openList()
                },
                blur: function($event) {
                  _vm.closeList()
                },
                keyup: _vm.change,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search = $event.target.value
                }
              }
            })
          ],
          {
            disabled: _vm.disabled,
            openList: _vm.openList,
            closeList: _vm.closeList,
            change: _vm.change,
            value: _vm.selected,
            label: _vm.selectedLabel,
            opened: _vm.open
          }
        ),
        _vm._v(" "),
        !_vm.spinner
          ? _c(
              "span",
              {
                class: [
                  _vm.open ? _vm.caretClass + "__open" : "" + _vm.caretClass
                ],
                on: {
                  mousedown: function($event) {
                    $event.preventDefault()
                    _vm.toggleOpen()
                  }
                }
              },
              [_vm._t("caret", [_c("i", { staticClass: "fa fa-caret-down" })])],
              2
            )
          : _c(
              "span",
              { class: _vm.caretClass + "__spinner" },
              [
                _vm._t("spinner", [
                  _c("i", { staticClass: "fa fa-spinner fa-spin" })
                ])
              ],
              2
            )
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.open,
            expression: "open"
          }
        ],
        ref: "options",
        class: _vm.listClass
      },
      [
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ],
            on: { mousemove: _vm.resetPointerEvents }
          },
          [
            _vm._l(_vm.data, function(option, index) {
              return [
                _c(
                  "li",
                  {
                    key: index,
                    ref: "option",
                    refInFor: true,
                    class: [
                      _vm.isActive(option) ? "select-option__active" : "",
                      _vm.atPosition(index) ? "select-option__hover" : "",
                      option.$isDisabled ? "select-option__disabled" : "",
                      _vm.itemClass
                    ],
                    on: {
                      mousedown: function($event) {
                        $event.preventDefault()
                        _vm.update(option)
                      },
                      mouseover: function($event) {
                        _vm.updatePosition(index, option.$isDisabled)
                      },
                      mouseleave: function($event) {
                        _vm.showSelect = false
                      }
                    }
                  },
                  [
                    _vm._t(
                      "option",
                      [
                        typeof option === "object"
                          ? [
                              _c("span", { class: _vm.labelClass }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.customLabel
                                      ? _vm.customLabel(option)
                                      : option[_vm.label]
                                  )
                                )
                              ])
                            ]
                          : [
                              _c("span", { class: _vm.labelClass }, [
                                _vm._v(_vm._s(option))
                              ])
                            ]
                      ],
                      { option: option }
                    ),
                    _vm._v(" "),
                    _vm.remove
                      ? [
                          _c(
                            "span",
                            {
                              staticClass: "remove-option pull-right",
                              on: {
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  _vm.$emit("remove", option)
                                }
                              }
                            },
                            [
                              _vm._t("removeIcon", [
                                _c("i", { staticClass: "fa fa-trash" })
                              ])
                            ],
                            2
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hideDeselect
                      ? _c("span", [
                          _vm.optionSelected(option)
                            ? _c("span", { staticClass: "selection" }, [
                                _vm._v("Deselect")
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.hideSelect
                      ? [
                          _vm.showSelect && _vm.atPosition(index)
                            ? _c(
                                "span",
                                { staticClass: "simple-select-select-text" },
                                [_vm._v("\n              Select\n            ")]
                              )
                            : _vm._e()
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            }),
            _vm._v(" "),
            _vm.data.length === 0
              ? _c("li", { class: _vm.itemClass }, [_vm._v("No results...")])
              : _vm._e()
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d41027e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d41027e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SimpleSelect.vue
// module id = null
// module chunks = 